import React from 'react';

const Clipboard = props => {
  return (
    <svg
      width="26"
      height="32"
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 19L12 22L18 16"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M16 4C16 2.343 14.657 1 13 1C11.343 1 10 2.343 10 4H7V8H19V4H16Z"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22 5H25V31H1V5H4"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default Clipboard;



// WEBPACK FOOTER //
// ./src/svg/Clipboard.js